export enum SocialAuthProvider {
  Yandex = 'YANDEX',
  Vk = 'VK',
}

export const SOCIAL_AUTH_CALLBACK_PATH: string = '/auth/social/callback';

export const YANDEX_AUTHORIZE_URL: string = 'https://oauth.yandex.ru/authorize';
export const VK_AUTHORIZE_URL: string = 'https://id.vk.ru/authorize';

export const OAUTH_STORAGE_KEYS: {
  readonly state: string;
  readonly provider: string;
  readonly returnUrl: string;
  readonly acceptMarketing: string;
  readonly selectFlow: string;
  readonly redirectUri: string;
} = {
  state: 'oauth_social_state',
  provider: 'oauth_social_provider',
  returnUrl: 'oauth_social_return_url',
  acceptMarketing: 'oauth_social_accept_marketing',
  selectFlow: 'oauth_social_select_flow',
  redirectUri: 'oauth_social_redirect_uri',
} as const;

/** Confluence GR-2584 / GR-2751: fallback when validate message empty */
export const SOCIAL_PHONE_NOT_AVAILABLE_FALLBACK: ReadonlyMap<SocialAuthProvider, string> = new Map([
  [
    SocialAuthProvider.Vk,
    'Невозможно авторизоваться через VK ID. У вашего аккаунта VK не привязан номер телефона. Войдите по номеру телефона.',
  ],
  [
    SocialAuthProvider.Yandex,
    'Невозможно авторизоваться через Yandex ID. У вашего аккаунта Yandex не привязан номер телефона. Войдите по номеру телефона.',
  ],
]);
